import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IAdminKnmKind } from '../interfaces/IAdminKnmKind';

/**
 * Получение списка видов КНМ для админки
 */
export async function fetchKnmKindsAll(): Promise<IAdminKnmKind[]> {
  return apiGet<IAdminKnmKind[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-kinds/all`);
}

/**
 * Обновление вида КНМ для админки
 * @param knmKind
 */
export async function updateKnmKind(knmKind: IAdminKnmKind): Promise<void> {
  const { dictionaryRecordId, ...data } = knmKind;

  return apiPut<void>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-kinds/${dictionaryRecordId}`,
    data,
  );
}
